import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { DialogActions } from '@material-ui/core'
import { CLOSE, SECONDARY } from 'app/constants/button'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import clsx from 'clsx'

const SelectGroupDialogFooter = ({
  onCloseDialog,
  onConfirm,
  isLoading,
  isSubmitting,
  confirmButtonTextLocaleKey = 'action.confirm',
  confirmButtonDisabled,
  closeButtonClassName,
  useDialogActions = false,
  className,
  id,
}) => {
  const isLoadingState = isLoading || isSubmitting

  const confirmText = <FormattedMessage id={confirmButtonTextLocaleKey} />

  const defaultCloseButtonClassName = clsx(
    'normal-case h-40',
    closeButtonClassName,
  )

  const buttons = (
    <>
      <ContainedButton
        id={id ? `${id}-closeBtn` : 'close-select-group-btn'}
        color={CLOSE}
        type="button"
        disabled={isLoadingState}
        onClick={onCloseDialog}
        className={defaultCloseButtonClassName}
      >
        <FormattedMessage id="text.close" />
      </ContainedButton>
      <ContainedButton
        id={id ? `${id}-confirmBtn` : 'add-to-group-btn'}
        color={SECONDARY}
        type="button"
        isLoading={isLoadingState}
        disabled={
          isLoadingState ||
          confirmButtonDisabled ||
          (confirmButtonDisabled === undefined && false)
        }
        onClick={onConfirm}
        className="normal-case h-40"
      >
        {confirmText}
      </ContainedButton>
    </>
  )

  if (useDialogActions) {
    return (
      <DialogActions className={clsx('justify-center pb-10', className)}>
        {buttons}
      </DialogActions>
    )
  }

  return (
    <div
      className={clsx(
        'flex justify-center space-x-5 py-10 flex-shrink-0',
        className,
      )}
    >
      {buttons}
    </div>
  )
}

SelectGroupDialogFooter.propTypes = {
  onCloseDialog: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  confirmButtonTextLocaleKey: PropTypes.string, // For FormattedMessage id (locale key), defaults to 'action.confirm'
  confirmButtonDisabled: PropTypes.bool,
  closeButtonClassName: PropTypes.string, // Optional className for close button (defaults to 'normal-case h-40')
  useDialogActions: PropTypes.bool, // Use DialogActions wrapper if true
  className: PropTypes.string, // Optional className override for container
  id: PropTypes.string,
}

export default SelectGroupDialogFooter
